module.exports = __webpack_public_path__ + "static/img/197.b3a524b3.gif";